<template>
  <v-container>
    <NavSidebar />
    <AdminUserList />
  </v-container>
</template>

<script>
import NavSidebar from '@/components/NavSidebar.vue';
import AdminUserList from '@/components/AdminUserList.vue';

export default {
  components: {
    NavSidebar,
    AdminUserList
  },
  data: () => ({
  }),
  methods: {
  }
}
</script>

<style>
.logo {
  max-height: 80px;
}
</style>
